import Hakuvahti from './Hakuvahti';

export default Hakuvahti;
